<div #wrapper class="video-wrap" [ngStyle]="{ position: position }">
  <video
    #video
    muted
    id="video"
    (canplay)="muteOnPlay()"
    playsinline
    autoplay
    loop
    preload
    volume="0"
    [class.fallback-image]="!posterImage"
  >
    <source [src]="videoURLWebm" type="video/webm" />
    <source [src]="videoURLMP4" type="video/mp4" />
    Sorry, your browser does not support HTML5 video.
  </video>
</div>
